module.exports = __webpack_public_path__ + "img/logo.ba2b8c84.png";